define('textAreaView',[
  'module',
  'underscore',
  'inputView',
  'template!textAreaView'
], function (
  Module,
  _,
  InputView,
  Tpl
) {
  'use strict';

  Module.exports = InputView.extend({
    template: Tpl,
    tagName: 'textarea',
    className: 'textarea-view ' + InputView.prototype.className,

    attributes: function () {
      return _.extend({}, InputView.prototype.attributes.apply(this, arguments), {});
    },

    events: {
      'keydown': 'onKeyDown',
      'change': 'onChange',
      'input': 'onInput'      
    },

    getValue: function () {
      return this.$el.val();
    },

    setValue: function (value) {
      this.$el.val(value);
    },

    onKeyDown: function(e) {
      if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault();
          if(this.options.onEnter) {
            this.options.onEnter();
            this.trigger('enter', e);
          }
      }

      if(this.options.onKeyDown) {
        this.options.onKeyDown(e);
        this.trigger('keydown', e);
      }
    },

    onChange: function(e) {
      if(this.options.onChange)
        this.options.onChange(e);

      this.trigger('change', this.getValue());
    },

    onInput: function(e) {
      if(this.options.onInput)
        this.options.onInput(e);

      this.trigger('input', this.getValue());
    } 
  });
});
  
